import { Reducer } from 'redux';
import produce from 'immer';

import { AdminState, AdminTypes } from './types';

const INITIAL_STATE: AdminState = {
  dashboard: {
    totalUsers: 0,
    activeUsers: 0,
    trialUsers: 0,
    usersNeedingPayment: [],
  },
  users: [],
  userDetail: {
    user: null,
    payments: [],
  },
  payments: [],
  loading: false,
};

const admin: Reducer<AdminState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AdminTypes.FETCH_DASHBOARD_REQUEST:
    case AdminTypes.FETCH_USERS_REQUEST:
    case AdminTypes.FETCH_USER_DETAIL_REQUEST:
    case AdminTypes.FETCH_PAYMENTS_REQUEST:
      return produce(state, draft => {
        draft.loading = true;
      });
    case AdminTypes.FETCH_DASHBOARD_SUCCESS:
      return produce(state, draft => {
        draft.dashboard = action.payload;
        draft.loading = false;
      });
    case AdminTypes.FETCH_USERS_SUCCESS:
      return produce(state, draft => {
        draft.users = action.payload.users;
        draft.loading = false;
      });
    case AdminTypes.FETCH_USER_DETAIL_SUCCESS:
      return produce(state, draft => {
        draft.userDetail = action.payload;
        draft.loading = false;
      });
    case AdminTypes.FETCH_PAYMENTS_SUCCESS:
      return produce(state, draft => {
        draft.payments = action.payload.payments;
        draft.loading = false;
      });
    case AdminTypes.FETCH_DASHBOARD_FAILURE:
    case AdminTypes.FETCH_USERS_FAILURE:
    case AdminTypes.FETCH_USER_DETAIL_FAILURE:
    case AdminTypes.FETCH_PAYMENTS_FAILURE:
      return produce(state, draft => {
        draft.loading = false;
      });
    default:
      return state;
  }
};

export default admin;
